<template>
  <div class="pa-0">
    <v-skeleton-loader v-if="loading" width="75px" type="text" />
    <div v-else class="text-wrap grafico-barra-percentual__label">
      <span v-html="dadosGrafico.label + ` (${dadosGrafico.quantity})`"></span>
    </div>
    <v-skeleton-loader v-if="loading" class="pt-2" type="text" />
    <div v-else class="pt-2 d-flex flex-row align-center">
      <v-progress-linear
        class="w-100"
        height="16"
        bg-opacity="1"
        rounded
        :buffer-opacity="1"
        :bg-color="dadosGrafico.bgColor"
        :model-value="dadosGrafico.percentage"
        :color="dadosGrafico.color"
        :max="100"
      />
      <div class="grafico-barra-percentual__percent-label" :style="{ color: dadosGrafico.percentageColor }">
        {{ `${dadosGrafico.percentageFormatted}%` }}
      </div>
    </div>
  </div>
</template>

<script>
import ModelGraficoBarraPercentual from '@/model/common/ModelGraficoBarraPercentual';

export default {
  props: {
    dadosGrafico: {
      type: Object,
      default: () => {
        return new ModelGraficoBarraPercentual();
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.grafico-barra-percentual__label {
  color: $neutral-color-high-medium;
}

.grafico-barra-percentual__percent-label {
  width: 55px;
  min-width: 55px;
  text-align: end;
}

::v-deep(.v-skeleton-loader) {
  background: transparent;
}

::v-deep(.v-skeleton-loader__text) {
  margin: 0;
}
</style>
